<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icons" clip-path="url(#clip0_4001_1272)">
      <path
        id="layer2"
        d="M10 19.375C15.1777 19.375 19.375 15.1777 19.375 10C19.375 4.82233 15.1777 0.625 10 0.625C4.82233 0.625 0.625 4.82233 0.625 10C0.625 15.1777 4.82233 19.375 10 19.375Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        id="layer1"
        d="M10 3.125V10.3125L14.0625 12.5"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>

    <defs>
      <clipPath id="clip0_4001_1272">
        <rect width="20" height="20" fill="transparent" />
      </clipPath>
    </defs>
  </svg>
</template>
